export default{
    msg:'',
    editar:{},
    lista:'',
    cbos:'',
}